import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { Box, Button, CircularProgress, FormGroup } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import {
  GetCCDAData,
  InsertPPLogs,
  SendDirectEmail,
  SendMailApi,
} from "../../../../api";
import Checkbox from "@mui/material/Checkbox";
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
// 
//FB  7075   08/03/2023  DK  Implement direct messaging feature

export default function DirectMail(props: any) {
  type CardProps = {
    ccdaid: string;
    created_Date: string;
  };

  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");

  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });
  const matches = useMediaQuery("(min-width:600px)");
  const [FromDate, setFromDate] = useState(new Date());
  const [ToDate, setToDate] = useState(new Date());
  const [card, setCardOpen] = useState(false);
  const [errorCard, setErrorCard] = useState(false);
  const [sentcard, setSentcard] = useState(false);
  const [CCDAattached, setCCDAattached] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [AttachResponse, setAttachResponse] = useState<Array<string>>([]);
  const [CCDAarray, setCCDAarray] = useState<Array<CardProps>>([
    {
      ccdaid: "",
      created_Date: "",
    },
  ]);
  const navigate = useNavigate();
  const JSAlert = require("js-alert");
  const [EmailResponse, setEmailResponse] = useState<Array<string>>([]);
  const [ids, setIds] = useState<Array<string>>([]);
  const handleClose = () => {
    setCardOpen(false);
    setErrorCard(false);
  };
  const handleMailClose = () => {
    setSentcard(false);
    setSentcard(false);
    setEmailAddress("");
    setContent("");
    setSubject("");
    setCCDAattached("");
  };
  const handleRadioChange = (event: any) => {
    AttachFiles();
    setCardOpen(false);
  };
  const handlechange = async () => {
    setIds([]);
    setCCDAattached("");
    const formattedFromDate = new Date(FromDate);
    const fromDateString = formattedFromDate.toLocaleDateString("en-ZA");
    const formattedToDate = new Date(ToDate);
    const toDateString = formattedToDate.toLocaleDateString("en-ZA");
    var sessionUser = sessionStorage.getItem("user");
    if (sessionUser != null) {
      const user = JSON.parse(sessionUser);
      if (user.Patient_n != null) {
        var data = await GetCCDAData(user.EMRID, fromDateString, toDateString);
        setCCDAarray(data);
        if (data.length != 0) {
          setCardOpen(true);
        } else {
          setErrorCard(true);
        }
      }
    }
  };
  const handleCheckboxChange = (event: any) => {
    const selectedId = event.target.value;
    if (ids.includes(selectedId)) {
      const newIds = ids.filter((id: any) => id !== selectedId);
      setIds(newIds);
      setCCDAattached(newIds.toString());
      if (newIds.length == 0) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    } else {
      const newIds = [...ids];
      newIds.push(selectedId);
      setIds(newIds);
      setCCDAattached(newIds.toString());
      if (newIds.length == 0) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }
  };
  const handleTochange = (e: any) => {
    setEmailAddress(e.target.value);
  };
  const handleSubjectchange = (e: any) => {
    setSubject(e.target.value);
  };

  async function AttachFiles() {
    const formattedFromDate = new Date(FromDate);
    const fromDateString = formattedFromDate.toLocaleDateString("en-ZA");
    const formattedToDate = new Date(ToDate);
    const toDateString = formattedToDate.toLocaleDateString("en-ZA");
    var sessionUser = sessionStorage.getItem("user");
    if (sessionUser != null) {
      const user = JSON.parse(sessionUser);
      if (user.Patient_n != null) {
        var data = await SendMailApi(
          ids,
          user.EMRID,
          fromDateString,
          toDateString
        );
      }
    }
    setAttachResponse(data);
  }

  async function SendEmail() {
    const reEmail = /^([a-zA-Z0-9_\-\.]+)(?!.*[_./#&+!$%*=?'`{|^_-]{2})([ A-Za-z0-9_./#&+!$%*=?'`{|^_-]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

    if (reEmail.test(emailAddress) == false) {
      JSAlert.alert("Please enter valid Email", null, JSAlert.Icons.Failed);
    } else if (emailAddress.split("@")[1].includes("direct") == false) {
      JSAlert.alert("Please enter a valid Direct email address", null, JSAlert.Icons.Failed);
    } else if (content == "") {
      JSAlert.alert("Please add a Message", null, JSAlert.Icons.Failed);
    } else if (subject == "") {
      JSAlert.alert("Please add a Subject", null, JSAlert.Icons.Failed);
    }
    else {
      setShowSpinner(true);
      let updatedContent = content.replace(/\n\r?/g, "<br/>");
      var data = await SendDirectEmail(
        AttachResponse,
        emailAddress,
        subject,
        updatedContent
      );
      if (!data) {
        JSAlert.alert("Failed to send the E-mail. Please try again later.", null, JSAlert.Icons.Failed);
        setShowSpinner(false);
      } else {
        setFromDate(new Date());
        setToDate(new Date());
        setEmailResponse(data);
        setSentcard(true);
        setShowSpinner(false);
      }
      InsertPPLogs(
        "Clicked on Send - Direct Mail",
        window.location.href,
        userName,
        emailAddress,
        data ? "Sent successfully" : "Failed to send"
      );
    }
  }

  async function InsertLogs() {
    InsertPPLogs("Viewing Direct Mail", window.location.href, userName, "");
  }

  useEffect(() => {
    InsertLogs();
  }, []);

  return (
    <div>
      <div
        className="row"
        style={{
          marginTop: matches == false ? "" : "90px",
          marginBottom: "30px",
        }}
      >
        <div className="col-sm-12">
          <div className="card" style={stylestop.container}>
            <div className="card-body">
              <p className="card-title" style={{ textAlign: "left" }}>
                <strong>Direct E-Mail</strong>
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>To : </strong>
                <input
                  id="standard-basic"
                  value={emailAddress}
                  onChange={handleTochange}
                  style={{
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                    wordWrap: "break-word",
                    width: "90%",
                  }}
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                ></input>{" "}
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Subject : </strong>{" "}
                <input
                  id="standard-basic"
                  value={subject}
                  onChange={handleSubjectchange}
                  style={{
                    width: "95%",
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                  }}
                ></input>{" "}
              </p>
              <hr></hr>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    InputLabelProps={{ shrink: true }}
                    format="MM/dd/yyyy"
                    label="From"
                    style={keybaord.container}
                    value={FromDate}
                    onChange={(newValue: any) => {
                      setFromDate(newValue);
                    }}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
              &nbsp;&nbsp;&nbsp;
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    InputLabelProps={{ shrink: true }}
                    format="MM/dd/yyyy"
                    label="To"
                    value={ToDate}
                    onChange={(newValue: any) => {
                      setToDate(newValue);
                    }}
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <button
                className="btn"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                  marginTop: "25px",
                }}
                onClick={handlechange}
              >
                Get Visit Record Files
              </button>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Message: </strong> <br></br>
              </p>
              <div className="col-sm-12">
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={8}
                  style={{
                    height: "200px",
                    width: "calc(100% - 5px)",
                  }}
                  value={content}
                  onChange={(e: any) => {
                    setContent(e.target.value);
                  }}
                />
              </div>
              <Dialog open={card} onClose={handleClose}>
                <DialogContent style={{ width: "500px", height: "300px" }}>
                  <hr></hr>
                  <h5>Choose Visit Record Files</h5>
                  <FormGroup>
                    {CCDAarray.map((x) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={x.created_Date}
                            onChange={handleCheckboxChange}
                            id={x.ccdaid}
                          />
                        }
                        label={x.created_Date}
                      />
                    ))}
                  </FormGroup>
                  <br></br>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: isDisabled ? "grey" : "#13607C",
                      color: "white",
                    }}
                    onClick={handleRadioChange}
                    disabled={isDisabled}
                  >
                    Attach
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#13607C",
                      color: "white",
                    }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </DialogContent>
                <DialogActions></DialogActions>
              </Dialog>
              <label>
                <strong>Attached Files:</strong>&nbsp;
                <h6>{CCDAattached}</h6>
              </label>
              <br></br>
              <br></br>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={SendEmail}
                endIcon={<CircularProgress size={20} style={{ color: "white", display: showSpinner ? "block" : "none" }} />}
              >
                Send
              </Button>{" "}
              {""}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={() => navigate("/user/home/dashboard")}
              >
                Cancel
              </Button>
              <Dialog open={sentcard} onClose={handleClose} fullWidth>
                <DialogContent style={{ height: "150px" }}>
                  <h5 style={{ textAlign: "center" }}>
                    E-Mail Sent Successfully
                  </h5>
                  <br></br>
                  <Box textAlign="center">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#13607C",
                        color: "white",
                      }}
                      onClick={handleMailClose}
                    >
                      Ok
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
              <Dialog open={errorCard} onClose={handleClose}>
                <DialogContent style={{ height: "150px" }}>
                  <h5 style={{ textAlign: "center" }}>No Visit Records Found</h5>
                  <br></br>
                  <Box textAlign="center">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#13607C",
                        color: "white",
                      }}
                      onClick={handleClose}
                    >
                      Ok
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    margin: "20px",
  },
};
const stylestop = {
  container: {
    height: "auto",
    border: "1px grey",
  },
};
const keybaord = {
  container: {
    fontSize: "10px",
  },
};